module.exports = __webpack_public_path__ + "static/media/2 (13).4fc375d7.jpg";